import React, { useEffect, useState } from "react";
import {
    Button,
    Col,
    Form,
    Row,
    Card,
    Typography,
    Space,
    Divider,
    Alert,
    Modal
} from "antd";
import TextArea from "antd/es/input/TextArea";
import {
    CheckOutlined,
    RollbackOutlined,
    CalendarOutlined,
    TagOutlined,
    FileTextOutlined,
    EditOutlined
} from "@ant-design/icons";
import {
    GetById_ObjectOutOfService_Api,
    Update_ObjectOutOfService_Api
} from "../../API/ObjectOutOfServiceApi";
import { CustomTypeCombo } from "../CustomType/CustomTypeCombo";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";


// ============================================
// کامپوننت اصلی
// ============================================
export const EditObjectOutOfServiceComponent = ({
    id,
    objectInstanceId,
    objectInstanceTitle,
    setLoading,
    showMessage,
    rowUpdated,
    cancelEdit,
    reasonParentId
}) => {
    const [form] = Form.useForm();
    const [reasonId, setReasonId] = useState();
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [initialData, setInitialData] = useState(null);


const { Title, Text } = Typography;
const SERVER_DATE_FORMAT = "YYYY-MM-DD";
// تابع کمکی برای تبدیل کاراکترهای فارسی به لاتین
    const persianToLatinDigits = (str) => {
        if (!str) return '';
        const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
        const latinDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        let newStr = str;
        for (let i = 0; i < 10; i++) {
            const regex = new RegExp(persianDigits[i], 'g');
            newStr = newStr.replace(regex, latinDigits[i]);
        }
        return newStr;
    };

    // ============================================
    // تبدیل رشته تاریخ شمسی به DateObject
    // ============================================
    const convertStringToDateObject = (dateString) => {
        if (!dateString) return null;
        
        try {
            // پاک کردن کاراکترهای اضافی
            const cleaned = String(dateString).replace(/[^0-9-]/g, '');
            
            let year, month, day;
            
            // اگر فرمت 1405-5-9 است
            if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(cleaned)) {
                const parts = cleaned.split('-');
                year = parseInt(parts[0]);
                month = parseInt(parts[1]);
                day = parseInt(parts[2]);
            }
            // اگر فرمت 1405-05-09 است
            else if (/^\d{4}-\d{2}-\d{2}$/.test(cleaned)) {
                const parts = cleaned.split('-');
                year = parseInt(parts[0]);
                month = parseInt(parts[1]);
                day = parseInt(parts[2]);
            }
            // اگر فرمت 14050509 است
            else if (/^\d{8}$/.test(cleaned)) {
                year = parseInt(cleaned.substring(0, 4));
                month = parseInt(cleaned.substring(4, 6));
                day = parseInt(cleaned.substring(6, 8));
            } else {
                return null;
            }
            
            // ایجاد DateObject با استفاده از کتابخانه react-multi-date-picker
            const dateObject = new DateObject({
                calendar: persian,
                locale: persian_fa,
                year: year,
                month: month,
                day: day
            });
            
            return dateObject;
        } catch (error) {
            console.error('خطا در تبدیل تاریخ:', error);
            return null;
        }
    };

    // تابع کمکی برای تبدیل DateObject به رشته
    const formatDateForApi = (dateObject) => {
        if (!dateObject) return '';
        
        // اگر رشته است
        if (typeof dateObject === 'string') {
            return persianToLatinDigits(dateObject);
        }
        
        // اگر DateObject از react-multi-date-picker است
        if (dateObject && typeof dateObject === 'object') {
            if (dateObject.year !== undefined && dateObject.month !== undefined && dateObject.day !== undefined) {
                const year = dateObject.year;
                const month = String(dateObject.month).padStart(2, '0');
                const day = String(dateObject.day).padStart(2, '0');
                return persianToLatinDigits(`${year}-${month}-${day}`);
            }
        }
        
        return '';
    };

// ===== تغییرات تاریخ =====
    const handleDateChange = (name, value) => {
        form.setFieldsValue({ [name]: value });
        if (name === "fromDate_Shamsi") setFromDate(value);
        if (name === "toDate_Shamsi") setToDate(value);
    };

    

    // ===== بارگذاری داده‌ها =====
    useEffect(() => {
        if (id) {
            loadData();
        }
    }, [id]);

    const loadData = async () => {
        setLoading(true);

        try {
            const data = await GetById_ObjectOutOfService_Api(id);
            setLoading(false);

            if (data.messageStatus === "Successful") {
                const item = data.messageData.data;
                setInitialData(item);
                
                // تبدیل رشته تاریخ به DateObject برای DatePicker
                const fromDateObj = convertStringToDateObject(item.fromDate_Shamsi);
                const toDateObj = convertStringToDateObject(item.toDate_Shamsi);
                
                form.setFieldsValue({
                    fromDate_Shamsi: fromDateObj,
                    toDate_Shamsi: toDateObj,
                    description: item.description || ""
                });
                
                setFromDate(fromDateObj);
                setToDate(toDateObj);
                setReasonId(item.customTypeId);
            } else {
                showMessage(data.message || "خطا در دریافت اطلاعات", "error");
            }
        } catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور", "error");
        }
    };

    // ===== ذخیره =====
    const onSubmit = async (values) => {
        // اعتبارسنجی علت
        if (!reasonId) {
            showMessage("لطفاً علت را انتخاب کنید", "error");
            return;
        }

        // اعتبارسنجی تاریخ
        if (!values.fromDate_Shamsi || !values.toDate_Shamsi) {
            showMessage("لطفاً تاریخ شروع و پایان را وارد کنید", "error");
            return;
        }

        // آماده‌سازی داده‌ها
        const formattedValues = {
            id: id,
            objectInstanceId: objectInstanceId,
            fromDate_Shamsi: formatDateForApi(values.fromDate_Shamsi),
            toDate_Shamsi: formatDateForApi(values.toDate_Shamsi),
            customTypeId: reasonId,
            description: values.description || "",
        };
        
        //console.log("داده‌های ارسالی به سرور:", formattedValues);
        
        if (formattedValues.fromDate_Shamsi > formattedValues.toDate_Shamsi) {
            showMessage("تاریخ پایان نمی‌تواند قبل از تاریخ شروع باشد", "error");
            return;
        }

        setLoading(true);

        try {
            const data = await Update_ObjectOutOfService_Api(formattedValues);
            setLoading(false);

            if (data.messageStatus === "Successful") {
                showMessage("اطلاعات با موفقیت بروزرسانی شد", "success");
                //rowUpdated();
                  cancelEdit();
            } else {
                showMessage(data.message || "خطا در بروزرسانی", "error");
            }
        } catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور", "error");
        }
    };

    // ===== انصراف با تایید =====
    const handleCancel = () => {
        // بررسی تغییرات
        const currentValues = form.getFieldsValue();
        const hasChanges = Object.keys(currentValues).some(
            key => currentValues[key] !== initialData?.[key]
        );

        if (hasChanges || reasonId !== initialData?.customTypeId) {
            Modal.confirm({
                title: 'آیا از انصراف مطمئن هستید؟',
                content: 'تغییرات اعمال شده ذخیره نخواهد شد',
                okText: 'بله، انصراف',
                cancelText: 'خیر، ادامه',
                onOk: () => {
                    form.resetFields();
                    setReasonId(null);
                    setFromDate(null);
                    setToDate(null);
                    if (cancelEdit) {
                        cancelEdit();
                    }
                }
            });
        } else {
            // اگر تغییری وجود نداشت، مستقیماً انصراف
            if (cancelEdit) {
                cancelEdit();
            }
        }
    };

    

    return (
        <div className="edit-object-container">
            {/* ===== هدر ===== */}
            <Card className="edit-object-header">
                <Row align="middle" gutter={[16, 16]}>
                    <Col xs={24} sm={24} md={24}>
                        <div className="sectionTitle">
                            <Title level={3} style={{ margin: 0, color: "#007bff" }}>
                                <EditOutlined style={{ marginLeft: 8 }} />
                                ویرایش خارج از سرویس
                            </Title>
                            <Text type="secondary" style={{ fontSize: 14 }}>
                               {objectInstanceTitle}
                            </Text>
                        </div>
                    </Col>
                </Row>
            </Card>

            {/* ===== فرم ===== */}
            <Card className="edit-object-form-card">
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onSubmit}
                >
                    <Row gutter={[24, 0]}>
                        {/* تاریخ شروع */}
                        <Col xs={24} sm={12} md={12} lg={8}>
                            <Form.Item
                                name="fromDate_Shamsi"
                                label={
                                    <Space>
                                        <CalendarOutlined style={{ color: "#007bff" }} />
                                        <Text strong>تاریخ شروع</Text>
                                        <Text type="danger">*</Text>
                                    </Space>
                                }
                                rules={[
                                    { required: true, message: "تاریخ شروع را وارد کنید" }
                                ]}
                            >
                                <DatePicker
                                    calendar={persian}
                                    locale={persian_fa}
                                    format="YYYY-MM-DD"
                                    value={fromDate}
                                    onChange={(dateObject) => handleDateChange("fromDate_Shamsi", dateObject)}
                                    placeholder="انتخاب تاریخ شروع"
                                    style={{
                                        width: "100%",
                                        height: "40px",
                                        borderRadius: "5px",
                                        border: "1px solid #d9d9d9",
                                        padding: "0 11px"
                                    }}
                                />
                            </Form.Item>
                        </Col>

                        {/* تاریخ پایان */}
                        <Col xs={24} sm={12} md={12} lg={8}>
                            <Form.Item
                                name="toDate_Shamsi"
                                label={
                                    <Space>
                                        <CalendarOutlined style={{ color: "#28a745" }} />
                                        <Text strong>تاریخ پایان</Text>
                                        <Text type="danger">*</Text>
                                    </Space>
                                }
                                rules={[
                                    { required: true, message: "تاریخ پایان را وارد کنید" }
                                ]}
                            >
                                <DatePicker
                                    calendar={persian}
                                    locale={persian_fa}
                                    format="YYYY-MM-DD"
                                    value={toDate}
                                    onChange={(dateObject) => handleDateChange("toDate_Shamsi", dateObject)}
                                    placeholder="انتخاب تاریخ پایان"
                                    style={{
                                        width: "100%",
                                        height: "40px",
                                        borderRadius: "5px",
                                        border: "1px solid #d9d9d9",
                                        padding: "0 11px"
                                    }}
                                />
                            </Form.Item>
                        </Col>

                        {/* علت */}
                        <Col xs={24} sm={24} md={24} lg={8}>
                            <Form.Item
                                label={
                                    <Space>
                                        <TagOutlined style={{ color: "#ffc107" }} />
                                        <Text strong>علت</Text>
                                        <Text type="danger">*</Text>
                                    </Space>
                                }
                                required
                            >
                                <CustomTypeCombo
                                    parentId={reasonParentId}
                                    value={reasonId}
                                    setLoading={setLoading}
                                    showMessage={showMessage}
                                    placeHolder="انتخاب علت"
                                    onChange={(value) => setReasonId(value)}
                                    style={{ width: "100%" }}
                                />
                            </Form.Item>
                        </Col>

                        {/* توضیحات - تمام عرض */}
                        <Col xs={24} sm={24} md={24} lg={24}>
                            <Form.Item
                                name="description"
                                label={
                                    <Space>
                                        <FileTextOutlined style={{ color: "#17a2b8" }} />
                                        <Text strong>توضیحات</Text>
                                    </Space>
                                }
                            >
                                <TextArea
                                    rows={4}
                                    placeholder="توضیحات (اختیاری)"
                                    maxLength={500}
                                    showCount
                                    style={{
                                        borderRadius: "5px",
                                        border: "1px solid #d9d9d9",
                                        padding: "10px",
                                        resize: "vertical"
                                    }}
                                />
                            </Form.Item>
                        </Col>

                        {/* هشدار تاریخ */}
                        {fromDate && toDate && fromDate > toDate && (
                            <Col xs={24}>
                                <Alert
                                    message="خطا در تاریخ"
                                    description="تاریخ پایان نمی‌تواند قبل از تاریخ شروع باشد"
                                    type="error"
                                    showIcon
                                    style={{ marginBottom: 16 }}
                                />
                            </Col>
                        )}
                    </Row>

                    {/* ===== دکمه‌ها ===== */}
                    <Divider />
                    <Row justify="center" gutter={[16, 16]}>
                        <Col xs={12} sm={8} md={6} lg={4}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                icon={<CheckOutlined />}
                                block
                                size="large"
                                style={{
                                    borderRadius: "10px",
                                    height: "45px",
                                    fontSize: "16px"
                                }}
                            >
                                بروزرسانی
                            </Button>
                        </Col>
                        <Col xs={12} sm={8} md={6} lg={4}>
                            <Button
                                icon={<RollbackOutlined />}
                                onClick={handleCancel}
                                block
                                size="large"
                                style={{
                                    borderRadius: "10px",
                                    height: "45px",
                                    fontSize: "16px",
                                    backgroundColor: "#6c757d",
                                    color: "#fff",
                                    borderColor: "#6c757d"
                                }}
                            >
                                انصراف
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </div>
    );
};